import { useCallback, useEffect, useState } from "react";
import { useGetRole } from "../../../lib/hooks/getRole";
import AccountsService from "../../../services/accounts";
import ContractsService from "../../../services/accounts/contracts";
import { Account } from "../../../types/Account";
import { useScrollToTableTop } from "../../../lib/hooks/useScrollToTableTop";

export const useFetchData = (request: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, isAdmin] = useGetRole();

  const { scrollToTop } = useScrollToTableTop();

  const [data, setData] = useState<Account[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const onSuccess = useCallback(
    (values: any) => {
      setData(values);
      scrollToTop(".clickable-rows-table");
      setIsLoading(false);
    },
    [scrollToTop]
  );

  const fetchData = useCallback((): void => {
    setIsLoading(true);
    !isAdmin
      ? AccountsService.fetchAccounts(request)
          .then((res: any) => {
            res &&
              onSuccess(
                res.map((item: any, i: number) => ({ ...item, id: i }))
              );
          })
          .catch(() => setIsLoading(false))
      : ContractsService.fetchAll(request)
          .then((res: any) => {
            onSuccess(res);
          })
          .catch(() => setIsLoading(false));
  }, [request, isAdmin, onSuccess]);

  useEffect(() => fetchData(), [fetchData]);

  return { data, isLoading, fetchData };
};
